var _style, _path, _path2, _path3, _path4, _path5, _path6, _rect, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSolarLogoWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Laag_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 541.1 155.9",
    style: {
      enableBackground: "new 0 0 541.1 155.9"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FF5000;}\n\t.st1{fill:#FFFFFF;}\n")), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M0,0v47.6h61.7C50.9,22,27.5,3.9,0,0z M27.3,107.5h72.3c3.3-8.2,5.3-16.9,5.7-25.8h-78L27.3,107.5z M81.3,51.9 H8.5v25.5h77.2C85.6,68.7,84.1,60.1,81.3,51.9z M0,155.9c26.1-3.7,48.7-20.2,60.1-44.1H0V155.9z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M290.7,88.3l2.6-0.2c0.1,0.9,0.4,1.8,0.9,2.6c0.5,0.7,1.2,1.3,2.1,1.6c1,0.4,2.1,0.6,3.2,0.6 c0.9,0,1.9-0.1,2.8-0.5c0.7-0.2,1.3-0.7,1.8-1.3c0.4-0.5,0.6-1.1,0.6-1.8c0-0.6-0.2-1.2-0.6-1.7c-0.5-0.6-1.2-1-1.9-1.2 c-1.2-0.4-2.4-0.7-3.7-1c-1.4-0.3-2.7-0.7-4-1.3c-0.9-0.4-1.6-1.1-2.2-1.9c-0.5-0.8-0.7-1.7-0.7-2.6c0-1,0.3-2.1,0.9-2.9 c0.6-0.9,1.5-1.7,2.6-2.1c1.2-0.5,2.5-0.7,3.8-0.7c1.4,0,2.7,0.2,4,0.7c1.1,0.4,2,1.2,2.7,2.2c0.6,1,1,2.1,1,3.3l-2.6,0.2 c-0.1-1.2-0.6-2.2-1.4-3c-1-0.7-2.3-1.1-3.6-1c-1.3-0.1-2.5,0.2-3.6,0.9c-0.7,0.5-1.1,1.3-1.1,2.2c0,0.7,0.3,1.4,0.8,1.8 c0.5,0.5,1.9,1,4.1,1.5c1.6,0.3,3.2,0.7,4.7,1.3c1.1,0.4,2,1.2,2.7,2.1c0.6,0.9,0.9,1.9,0.9,2.9c0,1.1-0.3,2.2-0.9,3.1 c-0.7,1-1.6,1.8-2.7,2.3c-1.3,0.6-2.6,0.8-4,0.8c-1.6,0.1-3.2-0.2-4.7-0.8c-1.2-0.5-2.3-1.4-3-2.5C291.1,90.8,290.7,89.6,290.7,88.3 z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M310.8,94.9V74.3h4.1l4.9,14.6c0.4,1.4,0.8,2.4,1,3.1c0.2-0.8,0.6-1.9,1.1-3.3l5-14.4h3.7v20.7h-2.6V77.6 l-6,17.3h-2.5l-6-17.6v17.6H310.8z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M335.3,94.9V74.3h2.7v20.7H335.3z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M348.1,94.9V76.7h-6.8v-2.4h16.4v2.4h-6.8v18.2H348.1z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M360.6,94.9V74.3h2.7v8.5h10.7v-8.5h2.7v20.7h-2.7v-9.7h-10.7v9.7H360.6z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 121.6,
    y: 110.4,
    className: "st1",
    width: 419.5,
    height: 2.9
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M404,80.5c-0.1-3.1-2.7-4.1-5-4.1c-1.7,0-4.6,0.5-4.6,3.6c0,1.7,1.2,2.3,2.4,2.6l5.8,1.3 c2.6,0.6,4.6,2.2,4.6,5.4c0,4.8-4.5,6.1-7.9,6.1c-3.8,0-5.2-1.1-6.1-1.9c-1.5-1.3-2.2-3.2-2.1-5.1h2.6c0,3.7,3,4.7,5.6,4.7 c2,0,5.3-0.5,5.3-3.4c0-2.1-1-2.8-4.3-3.6l-4.1-1c-1.3-0.3-4.3-1.2-4.3-4.8c0-3.2,2.1-6.3,7-6.3c7.1,0,7.8,4.2,7.9,6.5L404,80.5z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M419.5,95.4c-7.6,0-9.9-6.3-9.9-10.7s2.3-10.7,9.9-10.7s9.9,6.3,9.9,10.7S427,95.4,419.5,95.4z M419.5,76.5 c-4.4,0-7.1,3.5-7.1,8.2s2.7,8.3,7.1,8.3s7.1-3.5,7.1-8.2S423.9,76.5,419.5,76.5L419.5,76.5z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M435.4,92.4h10.3v2.4h-13V74.6h2.7L435.4,92.4z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M451.5,89l-2.1,5.9h-2.8l7.6-20.3h3.1l7.3,20.3h-3l-2-5.9L451.5,89z M458.6,86.6l-3-8.9h-0.1l-3.3,8.9H458.6z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M470.2,94.9h-2.7V74.6h9.4c3.3,0,6.7,1.2,6.7,5.4c0.1,2-1,4-2.8,4.9c1.2,0.5,2.3,1,2.4,3.8l0.2,3.7 c0,1.1,0.2,1.6,1,2v0.4h-3.4c-0.3-1.7-0.5-3.4-0.5-5.1c0-1.7-0.3-3.6-3.6-3.6h-6.6L470.2,94.9z M470.2,83.9h6.4c2,0,4.1-0.5,4.1-3.5 S478.4,77,477,77h-6.8V83.9z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M495.3,74.6h8.9c3.8,0,5.7,2.3,5.7,5.1c0.1,1.8-1,3.5-2.7,4.2c1.3,0.5,3.7,1.5,3.7,4.9c0,3.3-2.4,6-6.9,6h-8.7 L495.3,74.6z M498.1,83.2h4.9c2.6,0,4.2-0.8,4.2-3.3c0-1.9-1.2-3-4.2-3h-5L498.1,83.2z M498.1,92.5h5.8c2.9,0,4.3-1.4,4.3-3.7 c0-2.8-2.5-3.4-4.7-3.4h-5.4V92.5z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M516.9,94.9H514v-3h2.9L516.9,94.9z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M534.5,74.6h3.1l-7.4,20.3h-2.9l-7.4-20.3h3l5.8,17.3h0.1L534.5,74.6z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M540,94.9h-2.9v-3h2.9V94.9z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolarLogoWhite);
export default __webpack_public_path__ + "static/media/solar-logo-white.8fc4fe62290a83157af6e98f85d6c752.svg";
export { ForwardRef as ReactComponent };